<vp-availability-widget-input
	*ngrxLet="isSmallTablet$ as isSmallTablet"
	[className]="className"
	[header]="'global.period-of-stay' | translate"
	[isOpen]="_isOpen"
	[label]="'global.period-of-stay' | translate"
	[placeholder]="'global.choose-dates' | translate"
	[value]="prettyCombinedDates$ | async"
	(emitIsOpen)="popoverStateChanged($event)"
	iconName="icon-calendar"
	inputName="availability-date-range"
>
	<div
		[class.datepicker--hidden]="!_isOpen"
		class="card-md flex flex-col gap-2"
		data-test-id="availability-date-range"
		id="popover-input-date-range-picker"
	>
		@if (stepperConfig?.useStepper) {
			<div
				class="flex flex-row items-center justify-between gap-3 md:justify-start"
				data-test-id="nights-stepper-wrapper"
			>
				<label
					class="font-semibold text-dark-primary"
					for="night-stepper"
					>{{ 'global.number-of-nights' | translate }}
				</label>
				<vp-stepper
					[ariaDecreaseLabel]="'global.decrease-button' | translate"
					[ariaIncreaseLabel]="'global.increase-button' | translate"
					[max]="stepperConfig.max"
					[min]="stepperConfig.min"
					[value]="numberOfNights"
					(valueChange)="onNumberOfNightsChange($event)"
					inputId="night-stepper"
				/>
			</div>
		}
		<vp-calendar
			[calendarData]="filteredCalendarData$ | async"
			[config]="config$ | async"
			[isLoading]="isLoading"
			[jumpToFirstAvailableDate]="jumpToFirstAvailableDate"
			(datePickerEmitter)="onDatePickerEmitter($event)"
			(dayCreate)="addPricingToDayElement($event)"
			(emitHasError)="onEmitHasError($event)"
			(emitMonthChange)="onEmitMonthChange($event)"
		/>
		@if (showPrices() && false) {
			<span class="text-end text-sm text-dark-tertiary">
				{{ 'components.booking-widget.price-disclosure' | translate }}
			</span>
		}
	</div>
	<div
		class="flex flex-col gap-4"
		data-test-id="availability-date-range-footer"
		widget-input-footer
	>
		<div class="text-center">
			<div class="justify-center text-center">
				<span class="text-sm text-dark-tertiary" data-test-id="summary">
					{{
						(prettyCombinedDates$ | async) || 'global.choose-dates'
							| translate
					}}
				</span>
			</div>
		</div>
		<button
			(click)="onSubmitButtonClick()"
			class="btn btn-primary mt-auto w-full"
			data-test-id="date-cta-button"
		>
			{{ 'global.show-availability' | translate }}
		</button>
		<button
			(click)="onEmitBackButton($event)"
			class="flex items-center gap-1 text-sm text-dark-primary"
			data-test-id="date-back-button"
		>
			<svg-icon
				class="inline-block h-auto w-3"
				src="assets/icons/icon-chevron-left.svg"
			/>
			{{ 'global.back' | translate }}
		</button>
	</div>
</vp-availability-widget-input>
